import { memo } from 'react'
import { ValueText } from '@/features/Application/elements'
import formatCurrency from '@/utils/format-currency'
import SummaryContainer from './summary-container'

const CellComponent = ({ original, value, rate, hasWarning, hasData, isLocked }) => {
  return original === 'average_days_paid' ? (
    <SummaryContainer hasWarning={hasWarning} value={value} rate={rate} isLocked={isLocked} />
  ) : (
    <ValueText hasWarning={hasWarning} type="small" isLocked={isLocked} fontWeight="500">
      {hasData ? formatCurrency(value, { hideCents: true }) : '-'}
    </ValueText>
  )
}

export default memo(CellComponent)
